import React from 'react';
import cultureBanner from '../../assets/images/culture-banner-img.png';

const Banner = () => {
  return ( 
      <div className="culture-banner">
        <div className="culture-banner-desktop">
          <div className="banner-text pt-5 pb-5">
            <p className="fs-95 text-primary font-weight-thin">It's always <br></br>a good time<br></br> with SmartDrive.</p>
            <p className="text-gray fs-14 pt-5">At SmartDrive, we have a culture that<br></br> recognises and appreciates a job well<br></br> done, in addition to nurturing talent and<br></br> enabling growth</p>
          </div>
        </div>
        <div className="culture-banner-mobile">
          <p className="fs-95 text-primary font-weight-thin">It's always <br></br>a good time<br></br> with SmartDrive.</p>
          <img src={cultureBanner} alt="Banner" width="100%" />
          <p className="text-gray fs-14 pt-5">At SmartDrive, we have a culture that<br></br> recognises and appreciates a job well<br></br> done, in addition to nurturing talent and<br></br> enabling growth</p>
          </div>
      </div>
   );
}
 
export default Banner;
